import styled from "@emotion/styled";

export const P = styled.p`
  color: hsla(0, 0%, 100%, 0.75);
  margin: 0px;
  font-weight: 300;
  line-height: 24px;
  font-family: "Lexend Deca", sans-serif;
`;

export const H1 = styled.h1`
  color: hsla(0, 0%, 100%, 0.75);
  font-weight: 600;
  text-transform: uppercase;
  margin: 0px;
  font-size: 2rem;
  font-family: "Big Shoulders Display", cursive;
`;
export const H2 = styled.h2`
  color: hsla(0, 0%, 100%, 0.75);
  font-weight: 300;
  text-transform: uppercase;
  margin: 8px 0px;
  font-size: 2rem;
`;

export const H3 = styled.h3``;
export const H4 = styled.h4``;
export const H5 = styled.h5``;
